import React from 'react'
import { capitalize, startCase } from 'lodash-es'
import { useTranslation } from 'react-i18next'
import { Box, DataListItem } from '@node-space/ui-components'
import { CustomerDocumentStatusHighlight } from 'pages/Customers/components/CustomerHighlight'
import { DOCUMENT_TYPES } from '../helpers/constants'

type DocumentTypeKey = (typeof DOCUMENT_TYPES)[number]

interface CustomerDocumentsTabProps {
  pendingDocumentCodes: Set<string>
}

export const CustomerDocumentsTab = ({ pendingDocumentCodes }: CustomerDocumentsTabProps) => {
  const { t } = useTranslation()

  const isPending = (docKey: DocumentTypeKey) => pendingDocumentCodes.has(docKey)

  return (
    <Box className="flex flex-col gap-2" padding={16}>
      {DOCUMENT_TYPES.map((docKey, idx) => {
        const label = t(`embeddedCustomers.requiredDocuments.${docKey}`)
        const pending = isPending(docKey)
        const status = pending ? 'PENDING' : 'APPROVED'

        return (
          <DataListItem
            key={docKey}
            layout="horizontal"
            body=""
            title={`${idx + 1}. ${startCase(capitalize(label))}`}
            id={docKey}
            testId="customer-document"
            HeaderHighlight={
              <CustomerDocumentStatusHighlight status={status} isUploaded={!pending} />
            }
          />
        )
      })}
    </Box>
  )
}
